export const useVerticalStore = () => {
    const init = () => {
        window.Alpine.store("vertical", {
            value:
                typeof window.appContext?.Config?.vertical !== "undefined"
                    ? window.appContext.Config.vertical
                    : null,
        });
    };

    return {
        init,
    };
};
